import authorizedRequest from 'api/request/authorizedRequest';
import { PREFIX_API } from 'constants/api.const';
import { preprocessGetQuery } from 'helpers/api.helper';
import { getFormData } from 'helpers/form-data.helper';
import {
  ActiveAdvertisementPlaylistRequestModel,
  ActiveAdvertisementPlaylistResponseModel,
  DeleteAdvertisementPlaylistRequestModel,
  DeleteAdvertisementPlaylistResponseModel,
  GetAdvertisementPlaylistRequestModel,
  GetAdvertisementPlaylistResponseModel,
  InactiveAdvertisementPlaylistRequestModel,
  InactiveAdvertisementPlaylistResponseModel,
  ListAdvertisementPlaylistRequestModel,
  ListAdvertisementPlaylistResponseModel,
  SaveAdvertisementPlaylistRequestModel,
  SaveAdvertisementPlaylistResponseModel,
} from 'models/setting/advertisement/advertisement-playlist.model';

export function getAdvertisementPlaylist(
  payload: GetAdvertisementPlaylistRequestModel,
) {
  if (payload?.id) {
    return authorizedRequest.get<
      GetAdvertisementPlaylistResponseModel,
      GetAdvertisementPlaylistResponseModel
    >(`${PREFIX_API.GENERAL}/media-ads-lists/${payload?.id}`);
  }
}

export function listAdvertisementPlaylist(
  payload: ListAdvertisementPlaylistRequestModel,
) {
  return authorizedRequest.get<
    ListAdvertisementPlaylistResponseModel,
    ListAdvertisementPlaylistResponseModel
  >(`${PREFIX_API.GENERAL}/media-ads-lists?${preprocessGetQuery(payload)}`);
}

export function createAdvertisementPlaylist(
  payload: SaveAdvertisementPlaylistRequestModel,
) {
  const formDataPayload = getFormData(payload);

  return authorizedRequest.post<
    SaveAdvertisementPlaylistResponseModel,
    SaveAdvertisementPlaylistResponseModel
  >(`${PREFIX_API.GENERAL}/media-ads-lists`, formDataPayload, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function updateAdvertisementPlaylist(
  payload: SaveAdvertisementPlaylistRequestModel,
) {
  const formDataPayload = getFormData(payload);

  if (payload?.id) {
    return authorizedRequest.put<
      SaveAdvertisementPlaylistResponseModel,
      SaveAdvertisementPlaylistResponseModel
    >(`${PREFIX_API.GENERAL}/media-ads-lists/${payload?.id}`, formDataPayload, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export function deleteAdvertisementPlaylist(
  payload: DeleteAdvertisementPlaylistRequestModel,
) {
  return authorizedRequest.delete<
    DeleteAdvertisementPlaylistResponseModel,
    DeleteAdvertisementPlaylistResponseModel
  >(`${PREFIX_API.GENERAL}/media-ads-lists/${payload?.id}`);
}

export function inactiveAdvertisementPlaylist(
  payload: InactiveAdvertisementPlaylistRequestModel,
) {
  return authorizedRequest.put<
    InactiveAdvertisementPlaylistResponseModel,
    InactiveAdvertisementPlaylistResponseModel
  >(`${PREFIX_API.GENERAL}/media-ads-lists/${payload?.id}/inactive`);
}

export function activeAdvertisementPlaylist(
  payload: ActiveAdvertisementPlaylistRequestModel,
) {
  return authorizedRequest.put<
    ActiveAdvertisementPlaylistResponseModel,
    ActiveAdvertisementPlaylistResponseModel
  >(`${PREFIX_API.GENERAL}/media-ads-lists/${payload?.id}/active`);
}
